import React from "react";
import Input from "./Input";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { icon } from "leaflet";
import DeleteRowButton from "./DeleteRowButton";
import Axios from "../../../../node_modules/axios/index";

// const wrapWithGoogleMap = (Component) => {
//   const defaultProps = {
//     containerElement,
//     mapElement,
//   };
//   const WrappedComponent = withGoogleMap(Component);
//   return (props) => <WrappedComponent {...defaultProps} {...props} />;
// };

// @wrapWithGoogleMap
export class GoogleMapWithMarker extends React.PureComponent {
  render() {
    const {
      onMapLoad,
      onFocus,
      onBlur,
      onChange,
      position,
      defaultZoom,
      defaultCenter = position,
      readOnly = false,
      editedLocale,
    } = this.props;
    // const handleDragEnd = ({ latLng: { lat, lng } }) => {
    //   onChange && onChange({ lat: lat(), lng: lng() });
    //   onBlur && onBlur();
    // };
    // const handleDragEnd = (e) => {
    //   const { lat, lng } = e.target.getLatLng();
    //   onChange && onChange({ lat, lng });
    //   onBlur && onBlur();
    // };
    const handleDragEnd = async (event) => {
      const { lat, lng } = event.target.getLatLng();
      const { onChange, onBlur } = this.props;

      try {
        const response = await Axios.get("https://nominatim.openstreetmap.org/reverse", {
          params: {
            lat,
            lon: lng,
            format: "json",
          },
          headers: {
            "Accept-Language": `${
              editedLocale || "pl-PL,en-US,de-DE,es-ES,it-IT,ru-RU,cs-CZ"
            }`,
          },
        });

        const place = response.data;
        onChange &&
          onChange({
            name: place.display_name,
            lat,
            lng,
          });
        onBlur && onBlur();
      } catch (error) {
        console.error("Error fetching address data:", error);
      }
    };

    const customIcon = icon({
      iconUrl: "/images/icon-place.svg",
      iconSize: [32, 34],
      iconAnchor: [14, 38],
      popupAnchor: [2, -35],
      tooltipAnchor: [16, -28],
    });

    return (
      <Map
        ref={(ref) => ref && onMapLoad && onMapLoad(ref)}
        center={defaultCenter}
        zoom={defaultZoom}
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <TileLayer
          url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker
          draggable={!readOnly}
          position={position}
          onDragStart={!readOnly && onFocus}
          onDragEnd={!readOnly && handleDragEnd}
          icon={customIcon}
        >
          <Popup>
            <span>{position.name}</span>
          </Popup>
        </Marker>
      </Map>
      // <GoogleMap
      //   ref={(ref) => ref && onMapLoad && onMapLoad(ref)}
      //   defaultZoom={defaultZoom}
      //   defaultCenter={defaultCenter}
      // >
      //   {!!position && (
      //     <Marker
      //       draggable={!readOnly}
      //       position={position}
      //       onDragStart={!readOnly && onFocus}
      //       onDragEnd={!readOnly && handleDragEnd}
      //     />
      //   )}
      // </GoogleMap>
    );
  }
}

export default class Location extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this._listeners = [];
  }

  // componentWillUnmount() {
  //   delete this._mapRef;
  //   delete this._inputRef;
  //   delete this._gmap;
  //   delete this._searchBox;
  //   if (this._listeners) {
  //     this._listeners.forEach((l) => l.remove());
  //     delete this._listeners;
  //   }
  // }
  componentWillUnmount() {
    delete this._mapRef;
    delete this._inputRef;
    if (this._listeners) {
      this._listeners.forEach((l) => l.remove());
      delete this._listeners;
    }
  }

  // handleRenderInputSearchBox(inputRef) {
  //   const { readOnly, disabled } = this.props;
  //   if (!(readOnly || disabled) && inputRef && this._inputRef !== inputRef) {
  //     this._inputRef = inputRef;
  //     this._bindGoogleSearchBox();
  //   }
  // }
  handleRenderInputSearchBox(inputRef) {
    const { readOnly, disabled } = this.props;
    if (!(readOnly || disabled) && inputRef && this._inputRef !== inputRef) {
      this._inputRef = inputRef;
      this._bindSearchBox();
    }
  }

  // handleMapLoad(mapRef) {
  //   if (mapRef && this._mapRef !== mapRef) {
  //     this._inputRef && this._bindGoogleSearchBox();
  //     this._mapRef = mapRef;
  //     this._gmap = this._mapRef.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  //     this._listeners.push(
  //       this._gmap.addListener("bounds_changed", () => {
  //         this._searchBox && this._searchBox.setBounds(this._gmap.getBounds());
  //       })
  //     );
  //   }
  // }
  handleMapLoad(mapRef) {
    if (mapRef && this._mapRef !== mapRef) {
      this._inputRef && this._bindSearchBox();
      this._mapRef = mapRef;
    }
  }

  // _bindGoogleSearchBox() {
  //   const searchBox = (this._searchBox = new google.maps.places.SearchBox(this._inputRef));
  //   this._listeners.push(
  //     searchBox.addListener("places_changed", () => {
  //       const places = searchBox.getPlaces();
  //       if (places.length === 0) {
  //         return;
  //       }
  //       const place = places[0];
  //       if (!place.geometry) {
  //         return;
  //       }

  //       const bounds = new google.maps.LatLngBounds();
  //       if (place.geometry.viewport) {
  //         bounds.union(place.geometry.viewport);
  //       } else {
  //         bounds.extend(place.geometry.location);
  //       }

  //       this._gmap && this._gmap.fitBounds(bounds);

  //       this.props.onChange({
  //         name: this._inputRef.value,
  //         lat: place.geometry.location.lat(),
  //         lng: place.geometry.location.lng(),
  //       });
  //       this.props.onBlur && this.props.onBlur();
  //     })
  //   );
  // }
  // _bindSearchBox() {
  //   this._inputRef.addEventListener('input', this.handleSearchBoxInput.bind(this));
  // }
  _bindSearchBox() {
    this._inputRef.addEventListener("keydown", this.handleSearchBoxKeyDown.bind(this));
  }

  handleSearchBoxKeyDown(event) {
    if (event.key === "Enter") {
      this.handleSearchBoxInput(event);
    }
  }

  async handleSearchBoxInput(event) {
    const { editedLocale } = this.props;

    const query = event.target.value;
    if (!query) return;

    try {
      const response = await Axios.get("https://nominatim.openstreetmap.org/search", {
        params: {
          q: query,
          format: "json",
          addressdetails: 1,
          limit: 1,
        },
        headers: {
          "Accept-Language": `${
            editedLocale || "pl-PL,en-US,de-DE,es-ES,it-IT,ru-RU,cs-CZ"
          }`,
        },
      });

      const places = response.data;
      if (places.length === 0) {
        return;
      }

      const place = places[0];
      const bounds = [
        [place.boundingbox[0], place.boundingbox[2]],
        [place.boundingbox[1], place.boundingbox[3]],
      ];

      // this._mapRef.leafletElement.fitBounds(bounds);

      this.props.onChange({
        name: place.display_name,
        lat: parseFloat(place.lat),
        lng: parseFloat(place.lon),
      });
      this.props.onBlur && this.props.onBlur();
    } catch (error) {
      console.error("Error fetching location data:", error);
    }
  }

  render() {
    const {
      onFocus,
      onBlur,
      onChange,
      onRemove,
      value: location = {},
      defaultZoom = 14,
      showMap = true,
      placeholder = I18n.t("papp.components.LocationFormControl.placeholder"),
      readOnly,
      disabled,
      editedLocale,
      ...rest
    } = this.props;

    const handleDeleteClick = () => {
      onChange && onChange({ name: null, lat: null, lng: null });
      onBlur && onBlur();
    };
    const handleMapChange = (position) => {
      onChange && onChange({ ...location, ...position });
      onBlur && onBlur();
    };

    return (
      <div>
        <div className="u-positionRelative">
          <Input
            value={location.name === null ? "" : location.name}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange && ((name) => onChange({ ...location, name }))}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            {...rest}
            inputRef={this.handleRenderInputSearchBox.bind(this)}
            inputClassName="u-paddingRight"
          />
          {!(readOnly || disabled) && onChange && location.lat && location.lng && (
            <DeleteRowButton onClick={onRemove || handleDeleteClick} />
          )}
        </div>
        {!!(showMap && location.lat && location.lng) && (
          <div
            style={{
              display: "block",
              width: "100%",
              height: "300px",
              overflow: "hidden",
            }}
          >
            <GoogleMapWithMarker
              onMapLoad={this.handleMapLoad.bind(this)}
              defaultZoom={defaultZoom}
              position={location}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={handleMapChange}
              readOnly={readOnly || disabled}
              editedLocale={editedLocale}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Location.jsx